var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("DOCKING PROGRESS")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('ModalDocking', {
          attrs: {
            "action": _vm.dockingAction,
            "vehicle-id": _vm.selectedVehicleId,
            "docking-id": _vm.selectedDockingId
          },
          on: {
            "cancel": _vm.onCloseModalCreateDocking,
            "submit": _vm.onSubmitCreateDocking
          },
          model: {
            value: _vm.showDockingModal,
            callback: function callback($$v) {
              _vm.showDockingModal = $$v;
            },
            expression: "showDockingModal"
          }
        }), _c('ModalDockingActivity', {
          attrs: {
            "docking-id": _vm.selectedDockingId
          },
          on: {
            "cancel": _vm.onCloseModalActivityDocking,
            "submit": _vm.onSubmitActivityDocking
          },
          model: {
            value: _vm.showActivityDockingModal,
            callback: function callback($$v) {
              _vm.showActivityDockingModal = $$v;
            },
            expression: "showActivityDockingModal"
          }
        })];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-modal', {
          attrs: {
            "centered": "",
            "ok-title": "Filter",
            "title": "Filter Data"
          },
          on: {
            "ok": function ok($event) {
              return _vm.getDockingScheduleProgressData();
            }
          },
          model: {
            value: _vm.modal.filter,
            callback: function callback($$v) {
              _vm.$set(_vm.modal, "filter", $$v);
            },
            expression: "modal.filter"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Period",
            "label-for": "Period",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "format": "DD MMM YYYY",
            "type": "date",
            "range": "",
            "placeholder": "Select date range"
          },
          on: {
            "change": function change($event) {
              return _vm.onFilterChangeRangeDate();
            }
          },
          model: {
            value: _vm.lists.dateRange,
            callback: function callback($$v) {
              _vm.$set(_vm.lists, "dateRange", $$v);
            },
            expression: "lists.dateRange"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Fleet Category",
            "label-for": "fleet_category",
            "placeholder": "Select Fleet category",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "label": "name",
            "options": _vm.vehicleTypes,
            "reduce": function reduce(type) {
              return type.id;
            }
          },
          on: {
            "input": _vm.onChangeFleetCategory
          },
          model: {
            value: _vm.lists.params.vehicleTypeIds,
            callback: function callback($$v) {
              _vm.$set(_vm.lists.params, "vehicleTypeIds", $$v);
            },
            expression: "lists.params.vehicleTypeIds"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Vehicles",
            "label-for": "vehicleId",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.fleetFilteredOptions,
            "reduce": function reduce(fleetFilteredOptions) {
              return fleetFilteredOptions.value;
            },
            "placeholder": "Select Vehicle"
          },
          model: {
            value: _vm.lists.params.vehicleId,
            callback: function callback($$v) {
              _vm.$set(_vm.lists.params, "vehicleId", $$v);
            },
            expression: "lists.params.vehicleId"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Docking Type",
            "label-for": "docking_type",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('v-select', {
          attrs: {
            "options": _vm.dockingTypes
          },
          model: {
            value: _vm.lists.params.dockingType,
            callback: function callback($$v) {
              _vm.$set(_vm.lists.params, "dockingType", $$v);
            },
            expression: "lists.params.dockingType"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Status",
            "label-for": "status",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('v-select', {
          attrs: {
            "options": _vm.dockingStatus
          },
          model: {
            value: _vm.lists.params.dockingStatus,
            callback: function callback($$v) {
              _vm.$set(_vm.lists.params, "dockingStatus", $$v);
            },
            expression: "lists.params.dockingStatus"
          }
        })], 1)], 1)], 1)], 1), _c('div', {
          staticClass: "d-flex justify-content-between mb-3"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-form-input', {
          attrs: {
            "size": "md",
            "placeholder": "search..."
          }
        }), _c('b-button', {
          staticClass: "mx-2",
          attrs: {
            "variant": "primary"
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })]), _c('b-button', {
          staticClass: "d-flex align-items-center",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.toggleModalFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _c('p', {
          staticClass: "text-truncate m-0"
        }, [_vm._v(" Filter Data")])])], 1)]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("NO")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("FLEET")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("DOCKING TYPE")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("SHIPYARD")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("DOCKING DATE")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("COMPLETE DATE")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("JOB")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("STATUS")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("ACTION")])])]), _c('tbody', [_vm.lists.loading ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "9"
          }
        }, [_vm._v("Loading...")])]) : _vm._l(_vm.lists.data, function (data, index) {
          return _c('tr', {
            key: index,
            class: {
              'bg-danger': ['REJECT'].includes(data.status)
            }
          }, [_c('th', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.vehicle.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.dockingType))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.shipyard.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.dockingSchedule))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.deliveryDate))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(data.jobCount.finishedJob) + "/" + _vm._s(data.jobCount.totalJob))]), _c('td', {
            staticClass: "text-center"
          }, [['SEA_TRIAL'].includes(data.status) ? _c('b-badge', {
            attrs: {
              "variant": "success d-block"
            }
          }, [_vm._v("SEA TRIAL")]) : ['REVIEW'].includes(data.status) ? _c('b-badge', {
            attrs: {
              "variant": "warning d-block"
            }
          }, [_vm._v("NEED REVIEW")]) : ['HANDOVER'].includes(data.status) ? _c('b-badge', {
            staticClass: "text-white w-100",
            staticStyle: {
              "background-color": "#9E07E6"
            },
            attrs: {
              "variant": "d-block"
            }
          }, [_vm._v("SERAH TERIMA")]) : ['APPROVE'].includes(data.status) ? _c('b-badge', {
            attrs: {
              "variant": "primary d-block"
            }
          }, [_vm._v("NEED APPROVE")]) : ['PROGRESS'].includes(data.status) ? _c('b-badge', {
            attrs: {
              "variant": "info d-block"
            }
          }, [_vm._v("ON PROGRESS")]) : ['REJECT'].includes(data.status) ? _c('b-badge', {
            attrs: {
              "variant": "light d-block"
            }
          }, [_vm._v("REJECT")]) : _vm._e()], 1), _c('td', {
            staticClass: "text-center"
          }, [_c('b-dropdown', {
            attrs: {
              "size": "lg",
              "variant": "link iq-bg-primary iq-border-radius-10",
              "toggle-class": "text-decoration-none",
              "no-caret": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function fn() {
                return [_c('span', {
                  staticClass: "dropdown-toggle p-0",
                  attrs: {
                    "id": "dropdownMenuButton5",
                    "data-toggle": "dropdown"
                  }
                }, [_c('i', {
                  staticClass: "fa fa-ship m-0 text-primary"
                })])];
              },
              proxy: true
            }], null, true)
          }, [['REVIEW'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "variant": "warning"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalDocking(data, 'REVIEW');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-search mr-2"
          }), _vm._v("REVIEW")]) : _vm._e(), ['APPROVE'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "variant": "success"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalDocking(data, 'APPROVE');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-check mr-2"
          }), _vm._v("APPROVE")]) : _vm._e(), ['PROGRESS'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "variant": "info"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalActivityDocking(data);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-comments mr-2"
          }), _vm._v("ACTIVITY")]) : _vm._e(), ['PROGRESS', 'REVIEW'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "variant": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalDocking(data, 'UPDATE');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-plus-circle mr-2"
          }), _vm._v("ADD JOB")]) : _vm._e(), ['REJECT'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "variant": "danger"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalDocking(data, 'UPDATE');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-percent mr-2"
          }), _vm._v("UPDATE DOCKING")]) : _vm._e(), ['SEA_TRIAL'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "href": "#",
              "variant": "success"
            }
          }, [_c('router-link', {
            attrs: {
              "to": "/docking/sea-trial?dockingId=".concat(data.id)
            }
          }, [_c('i', {
            staticClass: "fa fa-ship mr-2"
          }), _vm._v("SEA TRIAL")])], 1) : _vm._e(), ['HANDOVER'].includes(data.status) ? _c('b-dropdown-item', {
            attrs: {
              "href": "#",
              "variant": "#9E07E6"
            }
          }, [_c('router-link', {
            attrs: {
              "to": "/docking/serah-terima?dockingId=".concat(data.id)
            }
          }, [_c('i', {
            staticClass: "fas fa-handshake mr-2"
          }), _vm._v("SERAH TERIMA")])], 1) : _vm._e(), _c('b-dropdown-item', {
            attrs: {
              "href": "#",
              "variant": "success"
            },
            on: {
              "click": function click($event) {
                return _vm.onOpenModalDocking(data, 'DETAIL');
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-info-circle"
          }), _vm._v(" DETAIL")])], 1)], 1)]);
        })], 2)]), _c('div', {
          staticClass: "mt-3"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.lists.meta.total,
            "per-page": _vm.lists.meta.perPage,
            "align": "center"
          },
          on: {
            "input": _vm.getDockingScheduleProgressData
          },
          model: {
            value: _vm.lists.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.lists.params, "page", $$v);
            },
            expression: "lists.params.page"
          }
        })], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }